import request from "@/utils/request";
import { ENABLE_API_DBG } from "@/appConfig.js";


function deptGrantList(params) {
  const newParams = { ...params };
  if (newParams.max) {
    newParams.take = newParams.max;
    delete newParams.max;
  }
  if (newParams.offset) {
    newParams.skip = newParams.offset;
    delete newParams.offset;
  }

  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    qsParams.append(key, value);
  }

  const url = `/dept-member-assignment?${qsParams.toString()}`;
  ENABLE_API_DBG && console.log(`api.deptGrantList.list: url = ${url}`);

  return request({
    url,
    method: "get",
    data: newParams,
  });
}

function chnlGrantList(params) {
  const newParams = { ...params };
  if (newParams.max) {
    newParams.take = newParams.max;
    delete newParams.max;
  }
  if (newParams.offset) {
    newParams.skip = newParams.offset;
    delete newParams.offset;
  }

  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    qsParams.append(key, value);
  }

  const url = `/channel-assignment?${qsParams.toString()}`;
  ENABLE_API_DBG && console.log(`api.chnlGrantList.list: url = ${url}`);

  return request({
    url,
    method: "get",
    data: newParams,
  });
}

function chnlGrantAsset(params) {
  const url = `/channel-assignment/`;
  ENABLE_API_DBG && console.log(`api.chnlGrantAsset: url = ${url}, params = ${JSON.stringify(params)}`);

  return request({
    url,
    method: "post",
    data: params,
  });
}

function chnlDelGrant(id) {
  const url = `/channel-assignment/${id}`;
  ENABLE_API_DBG && console.log(`api.chnlDelGrant: url = ${url}`);

  return request({
    url,
    method: "delete",
  });
}
function deptGrantAsset(params) {
  const url = `/dept-member-assignment/`;
  ENABLE_API_DBG && console.log(`api.deptGrantAsset: url = ${url}, params = ${JSON.stringify(params)}`);

  return request({
    url,
    method: "post",
    data: params,
  });
}

function deptDelGrant(id) {
  const url = `/dept-member-assignment/${id}`;
  ENABLE_API_DBG && console.log(`api.deptDelGrant: url = ${url}`);

  return request({
    url,
    method: "delete",
  });
}


export default {
  deptGrantList,
  chnlGrantList,
  chnlGrantAsset,
  deptGrantAsset,
  chnlDelGrant,
  deptDelGrant,
};
